import React from "react";
import { Tabs, Tab, Box } from "@material-ui/core";
import useStyles from "./ReadyToGoTabs.styles";

export default function ReadyToGoTabs({ tabs, value, onChange }) {
  const classes = useStyles();

  return (
    <Tabs
      className={classes.tabs}
      classes={{ indicator: classes.indicator }}
      value={value}
      onChange={(_, key) => onChange(key)}
      variant="scrollable"
      scrollButtons="auto"
    >
      {tabs.map(({ key, label, icon: Icon, count, disabled }) => {
        const text = count != null ? `${label} (${count})` : label;
        return (
          <Tab
            key={key}
            value={key}
            disabled={disabled}
            classes={{ root: classes.tab }}
            label={
              <Box className={classes.tabLabel}>
                {Icon && <Icon className={classes.icon} />}
                {text}
              </Box>
            }
          />
        );
      })}
    </Tabs>
  );
}
